import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { Trans } from '@lingui/macro';
import * as React from 'react';
import { MeasuredMultiIllustrationContainer } from '../components';
import { OtherProtectionsIllustrationSectionContent } from './illustration/content';

export const OtherProtectionsSection = (props: {
  widthLines?: ouiStyle.InStyleWithMediaQueries['widthLines'],
  index: number,
  titleBarHeight: number,
  setTitleBarHeight: any,
}) => {
  const {
    titleBarHeight,
    setTitleBarHeight,
    widthLines,
    index,
  } = props;
  return (
    <ouiDom.HeadingSection.HeadingSection
      index={index}
      name="OtherProtections"
      illustrationPosition="beforeOutside"
      widthLines={widthLines}
      innerDisplay={ouiStyle.Constants.DisplayProp.flex}
      innerFlexDirection={ouiStyle.Constants.InFlexDirectionProp.col}
      innerFlexReverse={[true, undefined, undefined, false, undefined, undefined]}
      mainDisplay={ouiStyle.Constants.DisplayProp.flex}
      mainFlexDirection={[ouiStyle.Constants.InFlexDirectionProp.col, undefined, undefined, ouiStyle.Constants.InFlexDirectionProp.row, undefined, undefined]}
      paddingHorizontal="simple"
      paddingTop={['none', undefined, undefined, 'simple', undefined, undefined]}
      paddingBottom="simple"
    >
      <TopModel
        name="HeadingSectionIllustrationContainer-OtherProtections"
        height={titleBarHeight}
        setHeight={setTitleBarHeight}
      >
        {MeasuredMultiIllustrationContainer}
      </TopModel>
      <TopModel
        name="HeadingSectionIllustrationContent-OtherProtections"
      >
        {OtherProtectionsIllustrationSectionContent}
      </TopModel>
      <ouiDom.P.P
        widthLines={['full', undefined, undefined, '1/2', undefined, undefined]}
        color={ouiStyle.Constants.Colors.primary}
        paddingHorizontal={['none', undefined, undefined, 'simple', undefined, undefined]}
      >
        <Trans>
          Vos liquidités et vos avoirs titres bénéficient des mêmes garanties que celles prévues dans les banques. Goldwasser Exchange est adhérent au fonds de protection.
        </Trans>
      </ouiDom.P.P>
      <ouiDom.P.P
        widthLines={['full', undefined, undefined, '1/2', undefined, undefined]}
        color={ouiStyle.Constants.Colors.primary}
        paddingHorizontal={['none', undefined, undefined, 'simple', undefined, undefined]}
      >
        <Trans>
          Vos titres sont placés hors du bilan de Goldwasser Exchange et donc hors d'atteinte d'éventuels créanciers de Goldwasser Exchange.
        </Trans>
      </ouiDom.P.P>
    </ouiDom.HeadingSection.HeadingSection>
  );
};
